module.exports = __webpack_public_path__ + "img/svg-resume.659a4a55.svg";